const errorHandler = (err) => {
  let error = "";

  const validationErrors = err?.response?.data?.errors;
  const customError = err?.response?.data?.message;
  const serverError = err?.response?.data?.errors?.message;
  const networkError = err?.toString();

  if (validationErrors && typeof validationErrors === "object") {
    const firstValidationError = Object.values(validationErrors).find(
      (value) => Array.isArray(value) && value.length > 0
    );

    if (firstValidationError) {
      error = firstValidationError[0];
    }
  }

  if (!error && customError) error = customError;
  else if (!error && serverError) error = serverError;
  else if (!error && networkError) error = networkError;
  else if (!error) error = "Oops! Something went wrong.";

  if (error === "Unauthorized") error = "Session Time out!";

  if (
    error === "Cancel: Requests cancelled!" ||
    error === "Error: Request failed with status code 400"
  ) {
    return;
  }

  return error;
};

export default errorHandler;
